    <div class="booking-detail" *ngIf="!loading; else spinner">
      <div class="page-header">
        <button mat-icon-button routerLink="/bookings" aria-label="Назад">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="page-title">Бронирование #{{ booking?.id }}</h1>
      </div>

      <div *ngIf="booking">
        <mat-card class="detail-card">
          <mat-card-content>
            <div class="status-row">
              <span>Статус:</span>
              <mat-chip-set>
                <mat-chip [class]="'status-' + booking.status" selected>
                  {{ booking.status | statusLabel:'booking' }}
                </mat-chip>
              </mat-chip-set>
            </div>

            <mat-list>
              <mat-list-item>
                <mat-icon matListItemIcon>directions_car</mat-icon>
                <span matListItemTitle>Автомобиль</span>
                <span matListItemLine>{{ booking.car_title }}</span>
              </mat-list-item>
              <mat-list-item *ngIf="booking.license_plate !== undefined">
                <mat-icon matListItemIcon>confirmation_number</mat-icon>
                <span matListItemTitle>Госномер</span>
                <span matListItemLine>{{ booking.license_plate || '—' }}</span>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>person</mat-icon>
                <span matListItemTitle>ФИО</span>
                <app-copy-text
                  matListItemLine
                  [value]="booking.client_name">
                </app-copy-text>
              </mat-list-item>
              <mat-list-item *ngIf="booking.client_phone">
                <mat-icon matListItemIcon>phone</mat-icon>
                <span matListItemTitle>Телефон</span>
                <app-copy-text
                  matListItemLine
                  [value]="booking.client_phone">
                </app-copy-text>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>event</mat-icon>
                <span matListItemTitle>Даты</span>
                <span matListItemLine>{{ formatDateTime(booking.start_date) }} — {{ formatDateTime(booking.end_date) }}</span>
              </mat-list-item>
              <mat-list-item *ngIf="booking.deposit_amount">
                <mat-icon matListItemIcon>account_balance_wallet</mat-icon>
                <span matListItemTitle>Залог</span>
                <span matListItemLine>{{ booking.deposit_amount }} &#8381;</span>
              </mat-list-item>
              <mat-list-item *ngIf="booking.rental_amount">
                <mat-icon matListItemIcon>payments</mat-icon>
                <span matListItemTitle>Сумма аренды</span>
                <span matListItemLine>{{ booking.rental_amount }} &#8381;</span>
              </mat-list-item>
            </mat-list>

            <mat-divider *ngIf="booking.notes"></mat-divider>
            <div *ngIf="booking.notes" class="notes-section">
              <strong>Заметки:</strong>
              <p>{{ booking.notes }}</p>
            </div>
          </mat-card-content>
        </mat-card>

        <div class="actions">
          <button mat-stroked-button [routerLink]="['/bookings', booking.id, 'report']" class="full-width-btn">
            <mat-icon>description</mat-icon> Отчёт для мессенджера
          </button>
        </div>

        <div class="actions">
          @if (booking.status !== BookingStatus.CANCELLED && booking.status !== BookingStatus.COMPLETED) {
            <button mat-raised-button color="primary" class="full-width-btn" (click)="confirmBooking()"
                    *ngIf="booking.status === BookingStatus.NEW">
                <mat-icon>check</mat-icon> Подтвердить
            </button>
            <button mat-raised-button color="accent" class="full-width-btn"
                    [routerLink]="['/rentals/new']" [queryParams]="{ booking: booking.id }"
                    *ngIf="booking.status === BookingStatus.CONFIRMED">
                <mat-icon>car_rental</mat-icon> Создать прокат
            </button>
            <button mat-raised-button color="primary" class="full-width-btn" (click)="completeBooking()"
                    *ngIf="booking.status === BookingStatus.CONFIRMED">
                <mat-icon>done_all</mat-icon> Завершить
            </button>
            <button mat-raised-button class="full-width-btn"
                    [routerLink]="['/bookings', booking.id, 'edit']">
                <mat-icon>edit</mat-icon> Редактировать
            </button>
            <button mat-stroked-button color="warn" class="full-width-btn" (click)="cancelBooking()">
                <mat-icon>cancel</mat-icon> Отменить
            </button>
          }
          <button mat-stroked-button color="warn" class="full-width-btn" (click)="deleteBooking()">
            <mat-icon>delete</mat-icon> Удалить
          </button>
        </div>
      </div>
    </div>

    <ng-template #spinner>
      <div class="loading-container"><mat-spinner diameter="40"></mat-spinner></div>
    </ng-template>
